/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import error from"../base/error";import isArray from"./isArray";const shuffle=function(r){if(!isArray(r))throw new error.IllegalArgument("arr parameter must be array");let e,o,t=r.length;for(;0!==t;)o=Math.floor(Math.random()*t),t-=1,e=r[t],r[t]=r[o],r[o]=e;return r};export default shuffle;